import Component from "../abstracts/Component";
import 'gsap';
import ScrollMagic from 'scrollmagic';
import 'debug.addIndicators';
import 'animation.gsap';

export default class BigVisualComponent extends Component {
  get SELECTORS() {
    return {
      main: '.c-big-visual',
    }
  }

  constructor(){
    super();

    this.controller = null;
  }

  bindEvent(el) {

    let image = el.querySelector('img');
    let direction = el.classList.contains('reverse-parallax') ? "30%" : "-10%";
    let tween = TweenMax.to(image, 1, {y: direction})

    new ScrollMagic.Scene({
      triggerElement: el,
      duration: el.offsetHeight
    })
    .setTween(tween)
    // .addIndicators()
    .addTo(this.controller);

  }

  render() {

    if(document.body.classList.contains('editMode')) return;

    if(this.$matchMedia('lg', null)){
      var elements = $(`${this.SELECTORS.main}.d-lg-none`);
    }else{
      var elements = $(this.SELECTORS.main);
    }

    if (elements.length > 0) {

      this.controller = new ScrollMagic.Controller();

      elements.each((index, element) => {
        this.bindEvent(element);
      });
    }
  }
}
